// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-766c3b0c].require> .el-input__inner{\n    border: red 1px solid;\n}\n.item[data-v-766c3b0c]{width:calc(100% - 30px)}\n", ""]);
// Exports
module.exports = exports;
